export default __webpack_public_path__ + "static/media/omoda-video.17f8804f.mp4";